export enum AdSenseOAuthStatus {
  None = "NotConnected",
  Success = "Connected",
  Failure = "Failure",
  Pending = "Verifying"
}